import {
  DEALER_PASSPORT_OPTION_STATUS,
  DEALER_TYPE_LIST,
} from "~/components/Forms/DealerPassportForm2/Base/options";
import { getFormatDate, parseDate } from '~/libs/getFormatDate';
import { dateFormat } from "~/shared/lib/DateFormat/dateFormat";

export const defaultFormValue = {
  dealerType: { value: null, label: "" },
  id: "",
  dealerName: "",
  legalDealerName: "",
  organizationalLegalForm: "",
  category: "",
  newDealer: { value: null, label: "" },
  main: { value: null, label: "" },
  headCompanyId: { value: null, label: "" },
  status: { value: null, label: "" },
  code: "",
  successorId: { value: null, label: "" },
  entfCode: "",
  entfSuccessorNo: "",
  entfSuccessorCode: "",
  holdingName: "",
  ladaBusiness: false,
  ladaSport: false,
};

export const toServer = (formData: any, dataDealer) => {
  const result = {
    id: parseInt(formData.id, 10) || dataDealer?.id || 0,
    dealerType:
      formData.dealerType?.value === "filial"
        ? "Филиал"
        : formData.dealerType?.value === "holding"
        ? "Холдинг"
        : "Автономный",
    sign: formData.sign ?? dataDealer?.sign ?? null,
    dealerName: formData.dealerName ?? dataDealer?.dealerName ?? "",
    legalDealerName:
      formData.legalDealerName ?? dataDealer?.legalDealerName ?? "",
    tradeDealerName:
      formData.tradeDealerName ?? dataDealer?.tradeDealerName ?? "",
    holdingName: formData.holdingName ?? dataDealer?.holdingName ?? "",
    organizationalLegalForm:
      formData.organizationalLegalForm ??
      dataDealer?.organizationalLegalForm ??
      "",
    category: formData.category ?? dataDealer?.category ?? "",
    newDealer: formData.newDealer?.value === 1 ? 1 : dataDealer?.newDealer || 0,
    main: formData.main?.value === 1 ? 1 : dataDealer?.main || 0,
    status:
      typeof formData.status === "object"
        ? formData.status?.value
        : formData.status ?? dataDealer?.status ?? "active",
    code: formData.code ?? dataDealer?.code ?? "",
    entfCode: formData.entfCode ?? dataDealer?.entfCode ?? "",
    entfSuccessorNo:
      formData.entfSuccessorNo ?? dataDealer?.entfSuccessorNo ?? "",
    entfSuccessorCode:
      formData.entfSuccessorCode ?? dataDealer?.entfSuccessorCode ?? "",
    successorCode: formData.successorCode ?? dataDealer?.successorCode ?? "",
    headCompanyId: formData.headCompanyId
      ? Number(formData.headCompanyId.value)
      : dataDealer?.headCompany?.id || null,
    successor:
      formData.successorId?.value && formData.successorId.value !== "-1"
        ? {
            id: Number(formData.successorId.value),
            dealerName: formData.successorId.label || "",
          }
        : dataDealer?.successor || null,
    photoDealerCenterId: formData.photoDealerCenterId
      ? Number(formData.photoDealerCenterId)
        ? Number(formData.photoDealerCenterId)
        : dataDealer?.PhotoDealerCenter.id
      : null,
    corporateEmail: formData.corporateEmail ?? dataDealer?.corporateEmail ?? "",
    hideOnLadaRu:
      formData.hideOnLadaRu?.value === 1 ? 1 : dataDealer?.hideOnLadaRu || 0,
    terminated:
      formData.terminated?.value === 1 ? 1 : dataDealer?.terminated || 0,
    extendedForNextYear:
      formData.extendedForNextYear?.value === 1
        ? 1
        : dataDealer?.extendedForNextYear || 0,
    protocolOfConclusion:
      formData.protocolOfConclusion ?? dataDealer?.protocolOfConclusion ?? "",
    protocolOfTermination:
      formData.protocolOfTermination ?? dataDealer?.protocolOfTermination ?? "",
    contractEndDate:
      formData.contractEndDate ?? dataDealer?.contractEndDate ?? "",
    dealerLadaserv:
      formData.DealerLADASERV?.value === 1
        ? "1"
        : dataDealer?.dealerLadaserv
        ? "1"
        : "0",
    kgaCode: formData.kgaCode ?? dataDealer?.kgaCode ?? "",
    onecCode: formData.onecCode ?? dataDealer?.onecCode ?? "",
    temporaryDecision:
      formData.temporaryDecision?.value === 1
        ? 1
        : dataDealer?.temporaryDecision || 0,
    entId: formData.entId
      ? String(formData.entId)
      : dataDealer?.entId
      ? String(dataDealer.entId)
      : null,
    consumerCode: formData.consumerCode ?? dataDealer?.consumerCode ?? "",
    birCode: formData.birCode ?? dataDealer?.birCode ?? "",
    xShopFlag:
      formData.xShopFlag?.value === 1 ? true : dataDealer?.xShopFlag || false,
    ladaBusiness: formData?.ladaBusiness ? true : false,
    ladaSport: formData.ladaSport ? true : false,
    beginWorkingDate: parseDate(formData.beginWorkingDate) ?? parseDate(dataDealer?.beginWorkingDate) ?? "",
  };

  return JSON.parse(JSON.stringify(result));
};

export const toForm = (dataDealer, currentHeadCompany) => {
  const contractEndDate = dateFormat(dataDealer.contractEndDate, {
    type: "date",
  });

  const beginWorkingDate = dateFormat(dataDealer.beginWorkingDate, {
    type: "date",
  });

  return {
    ...dataDealer,
    contractEndDate,
    dealerType: dataDealer?.dealerType
      ? DEALER_TYPE_LIST.filter(
          (item) => item.label === dataDealer.dealerType
        )[0]
      : { value: null, label: "" },
    status: dataDealer?.status
      ? DEALER_PASSPORT_OPTION_STATUS.filter(
          (item) => item.value === dataDealer.status
        )[0]
      : { value: null, label: "" },
    hideOnLadaRu: dataDealer?.hideOnLadaRu
      ? { value: 1, label: "Да" }
      : { value: 0, label: "Нет" },
    terminated: dataDealer?.terminated
      ? { value: 1, label: "Да" }
      : { value: 0, label: "Нет" },
    extendedForNextYear: dataDealer?.extendedForNextYear
      ? { value: 1, label: "Да" }
      : { value: 0, label: "Нет" },
    temporaryDecision: dataDealer?.temporaryDecision
      ? { value: 1, label: "Да" }
      : { value: 0, label: "Нет" },
    DealerLADASERV: dataDealer?.dealerLadaserv
      ? { value: 1, label: "Да" }
      : { value: 0, label: "Нет" },
    protocolOfIntentions: dataDealer?.protocolOfIntentions
      ? { value: 1, label: "Да" }
      : { value: 0, label: "Нет" },
    newDealer: dataDealer?.newDealer
      ? { value: 1, label: "Да" }
      : { value: 0, label: "Нет" },
    main: dataDealer?.main
      ? { value: 1, label: "Да" }
      : { value: 0, label: "Нет" },
    updatedAt: getFormatDate(dataDealer?.updatedAt, true),
    headCompanyId: currentHeadCompany,
    ladaBusiness: dataDealer.ladaBusiness,
    ladaSport: dataDealer.ladaSport,
    beginWorkingDate,
  };
};
